<template>
  <container-app class="w-100 p1" style="background: white">
    <header-app :title="$t('Review Order')" class="header-brand" to="menu" />
    <wrap class="row">
      <div class="col-md-7">

        <div class="row">
          <div class="col-md-12 col-sm-12">
               <h4 class="ml-2 mb-0 pb-0">{{ $t("Cart") }}</h4>
                <p class="ml-2 mb-2" style="color: #700E57"> <small>{{ hotel.title }}</small> </p >
       
          </div>
          <div class="col-md-12 col-sm-12" v-if="btnState == 'take_away'">  
              <pickup-time v-model="pickup_time"></pickup-time>
          </div>
        </div> 
       
        <div class="wrap-basket-card"> 

          <template v-if="orders.length > 0">
            <basket-card
              v-for="(order, index) in orders"
              :key="order.id"
              :item="order"
              :index="index"
              class="shadow-sm"
            />
          </template>
        </div>
      </div>
      <div class="col-md-5 shadow-sm">
        <div class="scoll-error" id="scollerror"></div>
        <!-- promotion -->
        <template v-if="promotion.id > 0">
          <div class="card basket-card">
            <div class="card-body">
              <div class="text">
                <div class="btnclose" />
                <h6 class="ml-3 mt-3">
                  {{ $t("Promotion") }}
                </h6>
                <h6 class="card-title ml-3 mt-3">
                  {{ promotion.title }}
                </h6>
              </div>
            </div>
          </div>
        </template>

        <!-- end promotion -->

        <!-- hotel_guest -->
        <div class="card basket-card" v-if="btnState === 'walk_in'">
          <div class="card-body">
            <div class="text">
              <base-walkin @valid="validInfo"></base-walkin>
            </div>
          </div>
        </div>

        <div class="card basket-card" v-if="btnState === 'hotel_guest'">
          <div class="card-body">
            <div class="text">
              <div class="btnclose" />
              <h6 class="ml-3 mt-3">
                {{ $t("Guest Information") }}
              </h6>
              <base-room-service @valid="validInfo"></base-room-service>
            </div>
          </div>
        </div>

        <!-- delivery service -->
        <div class="card basket-card" v-if="btnState === 'delivery'">
          <div class="card-body">
            <div class="text">
              <div class="btnclose" />
              <!-- <h6 class="ml-3 mt-3">
                {{ $t("Delivery Information") }}
              </h6> -->
              <base-delivery-map @valid="validInfo"></base-delivery-map>
            </div>
          </div>
        </div>
        <!-- <div class="card basket-card">
          <div class="card-body">
            <div class="text">
              <div class="btnclose" />
              <h6 class="ml-3 mt-3">
                {{ $t("Receiver") }}
              </h6>
            </div>
          </div>
        </div> -->

        <!-- end delivery service -->

        <!--  -->
        <div class="order-action">
          <div class="wrap-botttom-action">
            <div class="row">
              <div class="col-6">
                <p>{{ $t("sub_total") }}:</p>
              </div>
              <div class="col-6 text-right">
                {{  (sub_total) | exchange_rate_left }}
              </div>
              <div class="col-6">{{ $t("discount") }}:</div>
              <div class="col-6 text-right">
                <img
                  v-if="loading_promotion"
                  src="@/assets/loading.svg"
                  alt
                  width="20"
                />
                {{  (coupon_amount) | exchange_rate_left }}
              </div>
              <!--  -->
              <template v-if="delivery_fee.available">
                <div class="col-6">{{ $t("Delivery Fee") }}:</div>
                <div class="col-6 text-right">
                  {{  (delivery_fee.delivery_fee) | exchange_rate_left }}
                </div>
              </template>

              <div class="col-6">{{ $t("Total") }}:</div>
              <div class="col-6 text-right">
                {{  (total) | exchange_rate_left }}
              </div>

              <template v-if="hotel.tax_type === 'EXCLUSIVE'">
                <template v-if="hotel.service_charge > 0">
                  <div class="col-6">
                    <p>
                      {{ $t("Service Charge") }} {{ hotel.service_charge }}%
                    </p>
                  </div>
                  <div class="col-6 text-right">
                    {{  ((hotel.service_charge * total) / 100) | exchange_rate_left }}
                  </div>
                </template>

                <template v-if="hotel.tax > 0">
                  <div class="col-6">{{ $t("Tax") }} {{ hotel.tax }}%</div>
                  <div class="col-6 text-right">
                    {{  ((hotel.tax * total) / 100) | exchange_rate_left }}
                  </div>
                </template>
                <template>
                  <div class="col-6">
                    <p>{{ $t("Amount to be Paid") }}</p>
                  </div>
                  <div class="col-6 text-right">
                    <h5>
                      {{
                         (
                          (hotel.service_charge * total) / 100 +
                            (hotel.tax * total) / 100 +
                            total
                        ) | exchange_rate_left
                      }}
                    </h5>
                  </div>
                </template>
              </template>

              <template v-else>
                <div class="col-6">
                  <h5>{{ $t("Amount to be Paid") }}</h5>
                </div>
                <div class="col-6 text-right">
                  <h5>
                    {{   total | exchange_rate_left  }}
                  </h5>
                </div>
              </template>

              <template
                v-if="btnState === 'take_away' || btnState === 'delivery'"
              >
                <div class="col-12">
                  <hr />
                  {{ $t("Payment Method") }}:
                </div>
                <div class="col-12">
                  <div
                    class="btn-group btn-block mt-2"
                    style="
                      border-width: 1px;
                      border-style: dashed !important;
                      border-color: rgb(221, 224, 224);
                      border-radius: 10px;
                      padding: 5px;
                      background: #f5f8fa;
                    "
                  >
                    <button
                      v-for="(item, index) in paymentOption"
                      :key="index"
                      class="btn btn-text m-1"
                      :class="{
                        payment_option_selected: payment_option == item.option,
                      }"
                      @click="
                        (payment_option = item.option),
                          (modal_payment_option = false)
                      "
                    >
                      <span
                        v-if="payment_option == item.option"
                        class="svg-icon svg-icon-3x svg-icon-success"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                        >
                          <circle
                            fill="#000000"
                            opacity="0.3"
                            cx="12"
                            cy="12"
                            r="10"
                          />
                          <path
                            d="M16.7689447,7.81768175 C17.1457787,7.41393107 17.7785676,7.39211077 18.1823183,7.76894473 C18.5860689,8.1457787 18.6078892,8.77856757 18.2310553,9.18231825 L11.2310553,16.6823183 C10.8654446,17.0740439 10.2560456,17.107974 9.84920863,16.7592566 L6.34920863,13.7592566 C5.92988278,13.3998345 5.88132125,12.7685345 6.2407434,12.3492086 C6.60016555,11.9298828 7.23146553,11.8813212 7.65079137,12.2407434 L10.4229928,14.616916 L16.7689447,7.81768175 Z"
                            fill="#000000"
                            fill-rule="nonzero"
                          />
                        </svg>
                      </span>

                      {{ $t(item.option) }}
                    </button>
                  </div>
                  <!-- <button
                    type="button"
                    class="btn btn-sm btn-block shadow-sm"
                    @click="modal_payment_option = true"
                  >
                    <template v-if="payment_option != ''">
                      {{ $t(payment_option) }}
                    </template>
                    <template v-else>
                      {{ $t("Select_Payment") }}
                    </template>
                  </button> -->
                </div>
              </template>

              <!-- customer take away -->
              <template v-if="btnState == 'take_away'">
                <div class="col-12 mt-3" v-if="user">
                  <hr />
                  <p class="mb-2">{{ $t("Customer Information") }}</p>
                    <label for="">{{ $t('Name') }}:</label>
                    <input
                      v-model="customer_take_away.contact_fullname"
                      :disabled="true"
                      class="form-control form-control-solid"
                      :placeholder="$t('unknown')"
                      
                    />
                </div>
                <div class="col-12 mt-2" v-if="user">
                   <label for="">{{ $t('Phone') }}:</label>
                  <div class="input-group "> 
                    <input
                      type="number"
                      v-model="customer_take_away.phone" 
                      class="form-control form-control-solid"
                      :placeholder="$t('Phone Number')"
                    /> 
                  </div>  
                  <p v-if="!customer_take_away.phone" style="color: red"> {{ $t('Phone Number required') }}</p>
                  <hr />
                </div>
                <div class="col-12 mt-3" v-if="!user">
                  <p class="p-2" style="color: rgb(255 24 46)">
                    {{ $t('Login is required, to make order!')}}
                  </p>
                </div>
              </template>

              <div class="col-12" v-if="sub_total > 0">
                <div class="input-group mt-2">
                  <input
                    id="promo_code"
                    v-model="promo_code"
                    class="form-control form-control-solid"
                    :placeholder="$t('promotion code')"
                  />
                  <div class="input-group-append" v-if="promo_code != ''">
                    <button
                      class="btn"
                      type="button"
                      style="
                        margin-left: 5px;
                        background-color: #f5f8fa;
                        color: #181c32;
                        box-shadow: none !important;
                        border: 0;
                      "
                      @click="applyPromotionCode"
                    >
                      <img
                        v-if="loading_promotion"
                        src="@/assets/loading.svg"
                        alt
                        width="20"
                      />
                      {{ $t("Apply") }}
                    </button>
                  </div> 
                </div>
              </div>
              <div class="col-12">
                <div class="form-group mt-2">
                  <input
                    v-model="note"
                    class="form-control form-control-solid"
                    :placeholder="$t('Note')"
                  />
                </div>
              </div>
            </div>

            <div class="button mb-4">
              <button 
                @click="checkOut()"
                class="btn btn-block btn-brand shadow-sm btn-md ml-1 mt-3"
                :class="{'disabled': !validateData || order_loading}"
              >
                <span v-if="!order_loading"> {{ $t("Check Out") }}</span>
                <span v-else> {{ $t("Please wait...") }}</span>
              </button> 
            </div>
          </div>
        </div>
      </div>
    </wrap>

    <!-- modal coupon -->
    <div
      v-if="modal_coupon"
      class="modal shadow-lg fade show"
      tabindex="-1"
      role="dialog"
      style="display: block"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <base-icon icon_name="gift" />
              {{ $t("apply") }} {{ $t("coupon") }}
            </h5>
          </div>
          <div class="modal-body">
            <div class="form-group mx-sm-3 mb-2">
              <input
                v-model="coupon"
                type="text"
                class="form-control"
                :placeholder="$t('coupon')"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="modal_coupon = false"
            >
              {{ $t("close") }}
            </button>
            <btn-loading
              :loading="apply_loading_coupon"
              icon="send"
              title="apply"
              @click.native="ApplyCouponCode()"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modal_payment_option"
      class="modal shadow-lg fade show"
      tabindex="-1"
      role="dialog"
      style="display: block"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <h5 class="modal-title text-center mb-5">
              {{ $t("Select_Payment") }}
            </h5>
            <button
              v-for="(item, index) in hotel.payment_option"
              :key="index"
              class="btn btn-block btn-payment shadow-sm p-3"
              :class="{
                payment_option_selected: payment_option == item.option,
              }"
              @click="
                (payment_option = item.option), (modal_payment_option = false)
              "
            >
              {{ $t(item.option) }}
            </button>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="modal_payment_option = false"
            >
              {{ $t("close") }}
            </button>
          </div>
        </div>
      </div>
    </div>

 
  </container-app>
</template>
<script>
import moment from "moment";
import store from "@/store";
import { PAYMENT_OPTION } from "../constant";
export default {
  name: "Basket",
  middleware: "auth",
  data: () => ({
    pickup_time: '',
    modal_coupon: false,
    modal_payment_option: false,
    modal_update_phone: false,
    coupon: "",
    coupon_amount: 0,
    note: "",
    payment_option: "CASH_ON_DELIVERY",
    show_note: false,
    promo_code: "",
    validateData: false,
    customer_take_away: {
      phone: null
    }
  }),
  computed: {
    promotion_amount() {
      return store.getters["order/promotion_amount"];
    },
    loading_promotion() {
      return store.getters["order/loading_promotion"];
    },
    selected_currency() {
      return store.getters["currency/selected_currency"];
    },
    btnState() {
      return store.getters["location_selected/btnState"];
    },
    promotion() {
      return store.getters["order/promotion"];
    },
    delivery_fee() {
      return store.getters["order/delivery_fee"];
    },
    orders() {
      return store.getters["order/order"];
    },
    order_info() {
      return store.getters["order/order_info"];
    },
    order_pending() {
      return store.getters["order/pending_order"];
    },
    order_loading() {
      return store.getters["order/loading"];
    },
    state_order() {
      return store.getters["order/state_order"];
    },
    apply_loading_coupon() {
      return store.getters["order/apply_loading_coupon"];
    },
    hotel() {
      return store.getters["location_selected/placeSelected"] || {};
    },
    hotelType() {
      return store.getters["location_selected/placeType"];
    },
    sub_total() {
      let total_price = 0;
      _.forEach(this.orders, function (el) {
        total_price = Number(total_price) + Number(el.total_price);
      });
      return total_price;
    },
    total() {
      let total_ = this.sub_total - this.coupon_amount;
      if (this.delivery_fee.available) {
        total_ = total_ + +this.delivery_fee.delivery_fee || 0;
      }

      if (total_ < 0) return 0;
      return total_;
    },

    paymentOption() {
      let data_payment = [];
      this.hotel.payment_option.forEach((element) => {
        if (
          element.option == PAYMENT_OPTION.CASH_ON_DELIVERY &&
          (this.selected_currency.code === "KIP" ||
            this.selected_currency.code === "USD" ||
            this.selected_currency.code === "THB")
        ) {
          data_payment.push(element);
        }
        if (
          element.option == PAYMENT_OPTION.VISA_CARD &&
          this.selected_currency.code === "USD"
        ) {
          data_payment.push(element);
        }
        if (
          element.option == PAYMENT_OPTION.BCEL_ONE &&
          this.selected_currency.code === "KIP"
        ) {
          data_payment.push(element);
        }
      });

      return data_payment;
    },
    user() {
      return store.getters["auth/user"];
    },
  },
  watch: {
    sub_total: function (val) {
      this.updateOrder();
      this.applyPromotionCode();
    },
  },
  mounted() {
    if (this.orders.length <= 0) {
      this.$router.push({ name: "menu" });
    }
    this.applyPromotionCode();
    if (this.btnState === "take_away") {
      this.validateData = true;
    }
    if (this.paymentOption[0])
      this.payment_option = this.paymentOption[0].option;
    if(this.user)
     Object.assign ( this.customer_take_away, this.user )
      
  },
  methods: {
    checkDelivery() {
      let validate = false;
      if (
        this.btnState === "delivery" &&
        this.delivery_fee.available &&
        this.order_pending.lat &&
        this.order_pending.lng &&
        this.order_info.receiver_name &&
        this.order_info.customer_phone_number
      ) {
        validate = true;
      }
      return validate;
    },
    updateOrder() {
      this.submitOrder("pending");
    },
    async applyPromotionCode() {
      this.submitOrder("pending");
      if (this.promotion.id) {
        this.promo_code = this.promotion.code;
      }
      if (this.promo_code == "") return;
      let data = {
        items: [],
        total: this.sub_total,
        sub_total: this.sub_total,
        discount: this.coupon_amount,
        coupon: this.coupon,
        note: this.note,
        type_id: this.hotel.id,
        type: this.hotelType,
        currency_id: this.selected_currency.id,
        exchangerate: this.selected_currency.rate,
        order_type: this.btnState,
        promotion_code: this.promo_code,
      };
      _.forEach(this.orders, function (el) {
        let item = {
          item_id: el.item_id,
          qty: el.qty,
          price: el.price,
          options: [],
          note: el.note,
        };
        _.forEach(el.options, function (ell) {
          let options = {
            option_id: ell.option_id,
            optionvalues: [],
          };
          _.forEach(ell.optionvalues, function (elll) {
            options.optionvalues.push({ id: elll.opion_value_id });
          });
          item.options.push(options);
        });
        data.items.push(item);
      });
      await store.dispatch("order/CalcPromotion", data);

      if (this.promotion_amount.promotion_obj) {
        await this.$store.dispatch(
          "order/applyPromotion",
          this.promotion_amount.promotion_obj
        );
        this.coupon_amount = this.promotion_amount.promotion_amount;
      }
    },
    async ApplyCouponCode() {
      let formData = {
        type_id: this.hotel.id,
        type: this.hotelType,
        coupon: this.coupon,
        total: this.sub_total,
      };
      await store.dispatch("order/ApplyCouponCode", formData);
      let data = await store.getters["order/coupon_amount"];
      if (data > 0) {
        this.coupon_amount = data;
      }
      if (!this.apply_loading_coupon) {
        this.modal_coupon = false;
      }
    },
    validInfo(value) {
      this.validateData = value;
    },

    async submitOrder(status) {
      let data = {
        total: this.total,
        sub_total: this.sub_total,
        discount: this.coupon_amount,
        coupon: this.coupon,
        note: this.note,
        type_id: this.hotel.id,
        type: this.hotelType,
        currency_id: this.selected_currency.id,
        exchangerate: this.selected_currency.rate,
        local_status: status,
        order_type: this.btnState,
        promotion_id: this.promotion.id,
        payment_method: this.payment_option,
        pickup_datetime: this.pickup_time
      }; 
      
      if(moment(this.pickup_time) <= moment() || this.pickup_time == ""){
        data.pickup_datetime = moment().format('YYYY-MM-DD hh:mm A')
      }
 

      if (this.delivery_fee.delivery_fee) {
        data.delivery_fee = this.delivery_fee.delivery_fee;
      }

      await store.dispatch("order/submitOrder", data);

      if (this.state_order) {
        this.$store.dispatch("order/clearOrder");
        this.$router.push({ name: "ordercompleted" });
      }
    },
    async SubmitFinal() {
      if (this.btnState === "take_away" && this.user) {
         await store.dispatch("auth/updatePhoneNumber",{
           phone: this.customer_take_away.phone,
           customer_id: this.user.id
         }); 
      }
      await store.dispatch("order/submitPendingOrder", { id: 0 });
      if (this.state_order) { 
        let id = await store.getters["order/sale_id"];
        await this.$store.dispatch("order/clearOrder");
        if (this.payment_option == PAYMENT_OPTION.VISA_CARD) {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + `/payment/ordering/${id}/card`;
        }
        if (this.payment_option == PAYMENT_OPTION.BCEL_ONE) {
          window.location.href =
            process.env.VUE_APP_API_DOMAIN + `/payment/ordering/${id}/bcel_one`;
        }

        if (this.payment_option == PAYMENT_OPTION.CASH_ON_DELIVERY) {
          this.$router.push({ name: "ordercompleted" }); 
        }
      }
    },
    async checkOut() {
      if(!this.validateData || this.order_loading){
        if(!this.validateData)
        document.getElementById('scollerror').scrollIntoView({block: 'start', behavior: 'smooth', inline: "nearest"});
        return
      }
      this.submitOrder("pending");
      this.SubmitFinal();
    },

     
  },
};
</script>
<style lang="scss">
.coupon {
  margin: 10px 0px 10px 0;
}
.payment_option_selected {
  // background: #14a34b;
  color: #14a34b;
  border-radius: 5px;
}
.btn-payment:hover {
  color: white;
  background: #14a34b;
}

.svg-icon.svg-icon-success svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #14a34b;
}
</style>
